import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { Provider, useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { CookiesProvider } from 'react-cookie';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { ExtensionListPage } from '../modules/marketplace-consumer/components/extension-list-page';
import { AdminExtensionList, AdminExtensionEdit, AdminExtensionCreate, AdminExtensionStatistics, } from '../modules/marketplace-admin/components';
import { Analytics } from '../account/analytics/usage/account.analytics';
import { ExtensionDetails } from '../modules/marketplace-consumer/components/extension-details';
import { BlockedPage } from '../modules/core/components/blocked-page';
import { BlacklistedPage } from '../modules/core/components/blacklisted-page';
import { MeetingHistory } from '../account/analytics/meeting-history/account.meeting-history';
import { store } from '../store/store';
import { NotificationTop } from '../components/notification-top';
import { localeService, ROUTES, selectors as coreSelectors, } from '../modules/core';
import { components as Auth } from '../modules/auth';
import { defaultRichTextElements } from '../modules/core/components/with-providers/with-providers';
import growthbook from './global.experiments';
import { AdminSsoServiceList } from '../modules/sso/components/AdminSsoServiceList';
import { AdminSsoCreate } from '../modules/sso/components/AdminSsoCreate';
import { AdminSsoEdit } from '../modules/sso/components/AdminSsoEdit';
export const App = (props) => {
    const locale = useSelector(coreSelectors.getLocale);
    const [location, setLocation] = useState(null);
    useEffect(() => {
        setLocation(document.location.pathname);
    }, [document.location.pathname]);
    if (!location)
        return null;
    return (<CookiesProvider>
        <IntlProvider defaultRichTextElements={defaultRichTextElements} defaultLocale="en" messages={localeService.instance.messages} locale={locale || 'en'}>
          <GrowthBookProvider growthbook={growthbook}>
            <Router>
              <Switch>
                <Route path={ROUTES.signIn()} component={Auth.SignIn}/>
                <Route path={ROUTES.signUp()} component={Auth.SignUp}/>
                <Route path={ROUTES.paymentSetup()} component={Auth.PaymentSetup}/>
                <Route path={ROUTES.purchaseSuccess()} component={Auth.PurchaseSuccess}/>
                <Route path={ROUTES.extensionList()} component={ExtensionListPage}/>
                <Route path={ROUTES.analytics()} component={Analytics}/>
                <Route path={ROUTES.extensionDetails()} component={ExtensionDetails}/>
                <Route path={ROUTES.meetingHistory()} component={MeetingHistory}/>
                <Route path={ROUTES.adminExtensionList()} component={AdminExtensionList}/>
                <Route path={ROUTES.adminExtensionEdit()} component={AdminExtensionEdit}/>
                <Route path={ROUTES.adminExtensionCreate()} component={AdminExtensionCreate}/>
                <Route path={ROUTES.adminExtensionStatistics()} component={AdminExtensionStatistics}/>
                <Route path={ROUTES.blockedPage()} component={BlockedPage}/>
                <Route path={ROUTES.blacklistedPage()} component={BlacklistedPage}/>
                <Route path={ROUTES.adminSsoServices()} component={AdminSsoServiceList}/>
                <Route path={ROUTES.adminSsoServiceCreate()} component={AdminSsoCreate}/>
                <Route path={ROUTES.adminSsoServiceEdit()} component={AdminSsoEdit}/>

              </Switch>
            </Router>

            <NotificationTop />
          </GrowthBookProvider>
        </IntlProvider>
      </CookiesProvider>);
};
const Root = (props) => {
    return (<Provider store={store}>
      <App {...props}/>
    </Provider>);
};
export const RenderWithWrapper = (Component, props, target, $scope = null) => {
    const wrapped = (<Provider store={store}>
      <Internalization>
        <GrowthBookProvider growthbook={growthbook}>
          <Component {...props}/>
        </GrowthBookProvider>
      </Internalization>
    </Provider>);
    ReactDOM.render(wrapped, target);
    if (!!$scope) {
        $scope.$on('$destroy', () => {
            ReactDOM.unmountComponentAtNode(target);
        });
    }
};
export const Internalization = ({ children }) => {
    const locale = useSelector(coreSelectors.getLocale);
    return (<IntlProvider defaultRichTextElements={defaultRichTextElements} defaultLocale="en" messages={localeService.instance.messages} locale={locale || 'en'}>
      {children}
    </IntlProvider>);
};
export default Root;
